import StringArray from "./StringArray";
export default StringArray;
